
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { PlanReplacementModel } from './Entities.GormCrm.PlanReplacement';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class PlanReplacementOldPlanModel extends Model<PlanReplacementOldPlanModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'planReplacementOldPlan.property.id', isHidden: true },
		{ name: 'planReplacementId', type: 'guid', languageString: 'planReplacementOldPlan.property.planReplacementId' },
		{ name: 'productPlanId', type: 'guid', languageString: 'planReplacementOldPlan.property.productPlanId' },
		{ name: 'adjustmentAmount', type: 'number', languageString: 'planReplacementOldPlan.property.adjustmentAmount' },
		{ name: 'remainingValue', type: 'number', languageString: 'planReplacementOldPlan.property.remainingValue' },
		{ name: 'planReplacement', type: 'PlanReplacementModel', languageString: 'planReplacementOldPlan.property.planReplacement', isHidden: true, isObject: true, new: () => { return new PlanReplacementModel }, properties: () => { return PlanReplacementModel.classProperties } },
		{ name: 'productPlan', type: 'ProductPlanModel', languageString: 'planReplacementOldPlan.property.productPlan', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public planReplacementId?: string;
	public productPlanId?: string;
	public adjustmentAmount: number;
	public remainingValue: number;
	public planReplacement?: PlanReplacementModel;
	public productPlan?: ProductPlanModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.planReplacementId = undefined;
		this.productPlanId = undefined;
		this.adjustmentAmount = 0;
		this.remainingValue = 0;
		this.planReplacement = undefined;
		this.productPlan = undefined;
		
	}
	getProperties(){
		return PlanReplacementOldPlanModel.classProperties;
	}
}

